import React from 'react';
import { Link } from 'react-router-dom';

const CTABox: React.FC = () => {
  return (
    <div className="my-8 md:my-12 bg-gradient-to-br from-orange-50 to-white rounded-2xl border-2 border-orange-200 p-6 md:p-12 text-center shadow-lg">
      <div className="max-w-3xl mx-auto">
        <div className="text-4xl md:text-5xl mb-3 md:mb-4">🔍</div>
        <h3 className="text-xl md:text-3xl font-bold text-gray-800 mb-3 md:mb-4">
          Nicht das Richtige gefunden?
        </h3>
        <p className="text-gray-600 mb-6 md:mb-8 text-sm md:text-lg">
          Du kannst entweder den <strong className="text-orange-600">KI-Assistenten</strong> oben nutzen
          oder klassisch nach Kategorie filtern — ganz wie du möchtest.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold hover:shadow-lg transition-all transform hover:scale-105 text-sm md:text-base"
          >
            🤖 KI-Assistent nutzen
          </button>
          <Link
            to="/products"
            className="bg-white border-2 border-orange-500 text-orange-600 px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold hover:bg-orange-50 transition-all transform hover:scale-105 shadow-md text-sm md:text-base"
          >
            🗂 Klassisch nach Kategorie filtern
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CTABox;
